import React from 'react';
import Row from './row';
import './table.css';

const transformFnDefault = data => data;

const Table = ({ headerTitles = [], data = [], transformFn = transformFnDefault, actions = {}, openModalChangeToInspection = () => {}, isViewer }) => (
    <table>
        <thead className="thead-default">
            <tr className="text-black">
                {headerTitles && headerTitles.map((e, index) => <th key={index}>{e}</th>)}
            </tr>
        </thead>
        <tbody>
            {
                (data.length > 0) ?
                    data.map((item, index) => (
                        <Row data={item} transformFn={transformFn} key={index} actions={actions} openModalChangeToInspection={openModalChangeToInspection} isViewer={isViewer}/>
                    ))
                    :
                    <tr><td colSpan={headerTitles.length} className="text-md--light text-center">No se encontraron registros....</td></tr>
            }
        </tbody>
    </table>
);

export default Table;



// WEBPACK FOOTER //
// ./src/components/shared/table/index.jsx